<div class="tab-list">
  <button class="item-list" *ngFor="let item of items" [ngClass]="{ active: item.active }" (click)="onSelectTab(item)">
    <span *ngIf="item.iconName" class="material-symbols-outlined icon">{{ item.iconName }}</span>
    <img *ngIf="item.customIconSrc" [src]="item.customIconSrc" alt="{{ item.name }} icon" />
    <span>{{ item.name }}</span>
  </button>
</div>
